/** 排行榜分类 */
export enum RANK_TAB_TYPE {
  /** AI创作 */
  AI_CREATORS = 'AI_CREATORS',
  /** 合集榜 */
  COLLECTIONS = 'COLLECTIONS',
  /** 作品榜 */
  WORKS = 'WORKS',
  /** 创作者榜 */
  CREATORS = 'CREATORS',
}

/** 时间切换类型 */
export type TIME_TAB_CHANGE_TYPE = (
  timeValue: any,
  type: string,
  parentType: string
) => void

/** 首页列表数据类型 */
export type INDEX_RANK_ITEM_LIST_TYPE<T> = {
  /** 父级类型 */
  parentType: RANK_TAB_TYPE
  /** tab类型 */
  type: string
  /** tab名称 */
  name: string
  /** 数据列表 */
  data: T[]
  /** 时间筛选 */
  timeTabsList?: TabsItemProps[]
  /** 时间切换时 */
  onTimeChange?: TIME_TAB_CHANGE_TYPE
}

/** tab子项目 */
export type TabsItemProps = {
  key: string
  name: string
}

/** 首页tab分类 */
export const indexTabList = [
  { key: RANK_TAB_TYPE.AI_CREATORS, name: 'AI创作', icon: 'pen' },
  { key: RANK_TAB_TYPE.COLLECTIONS, name: '合集榜', icon: 'portfolio' },
  { key: RANK_TAB_TYPE.WORKS, name: '作品榜', icon: 'printmaking' },
  { key: RANK_TAB_TYPE.CREATORS, name: '创作者', icon: 'user' },
]
